export const LifecycleRoutes = {
	Local: 'http://localhost:1500',
	LocalLive: 'http://localhost:1510',
	Cypress: 'http://localhost:1520',
	Test: 'https://lifecycle.stage.agilox.net',
	Stage: 'https://lifecycle.stage.agilox.net',
	Beta: 'https://lifecycle.beta.agilox.net',
	Live: 'https://lifecycle.agilox.net',
} as const;
